import i18next from "i18next";
import { call, put, takeLatest } from "redux-saga/effects";
import { getTermintypen } from "../../../api/commonApi";
import { i18_TRANSLATION } from "../../../i18nReferences";
import { createErrorNotification } from "../../../models/notification";
import { emitNotificationAction } from "../../notification/notificationAction";
import { extractDataFromResponse } from "../../saga-utils/httpInterceptorWrapper";
import { RELOAD_COMMON_TERMINTYPEN, reloadCommonStudioFailureAction, reloadCommonTermintypenSuccessAction } from "../commonActions";

function* processReloadTermintypen() {
    try {
        const termintypMap = extractDataFromResponse(yield call(getTermintypen))
        yield put(reloadCommonTermintypenSuccessAction(termintypMap))
    } catch (err) {
        console.log(err)
        yield put(reloadCommonStudioFailureAction())
        yield put(emitNotificationAction(createErrorNotification(i18next.t('COMMON.LOAD_STUDIO_DATA_FAILED_INFO', {ns: i18_TRANSLATION}), 'loadCommon')))
    }
}

export function* watchReloadTermintypen() {
    yield takeLatest([RELOAD_COMMON_TERMINTYPEN], processReloadTermintypen)
}